export default [
  {
    label: "United States",
    value: "united-states",
    iso_country_code: "us"
  },
  {
    label: "Europe",
    value: "Europe",
    iso_country_code: "eu"
  },
  {
    label: "Canada",
    value: "canada",
    iso_country_code: "ca"
  },
  {
    label: "United Kingdom",
    value: "united-kingdom",
    iso_country_code: "gb"
  },
  {
    country_id: 55,
    iso_country_code: "af",
    world_bank_country_code: "AFG",
    label: "Afghanistan",
    value: "afghanistan",
    lat: 33.78,
    lon: 66.17
  },
  {
    country_id: 306,
    iso_country_code: "ax",
    world_bank_country_code: "ALA",
    label: "Åland Islands",
    value: "aland-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 57,
    iso_country_code: "al",
    world_bank_country_code: "ALB",
    label: "Albania",
    value: "albania",
    lat: 41.14,
    lon: 20.26
  },
  {
    country_id: 95,
    iso_country_code: "dz",
    world_bank_country_code: "DZA",
    label: "Algeria",
    value: "algeria",
    lat: 28.14,
    lon: 2.83
  },
  {
    country_id: 250,
    iso_country_code: "as",
    world_bank_country_code: "ASM",
    label: "American Samoa",
    value: "american-samoa",
    lat: null,
    lon: null
  },
  {
    country_id: 228,
    iso_country_code: "ad",
    world_bank_country_code: "AND",
    label: "Andorra",
    value: "andorra",
    lat: null,
    lon: null
  },
  {
    country_id: 56,
    iso_country_code: "ao",
    world_bank_country_code: "AGO",
    label: "Angola",
    value: "angola",
    lat: -12.36,
    lon: 17.74
  },
  {
    country_id: 251,
    iso_country_code: "ai",
    world_bank_country_code: "AIA",
    label: "Anguilla",
    value: "anguilla",
    lat: null,
    lon: null
  },
  {
    country_id: 252,
    iso_country_code: "ag",
    world_bank_country_code: "ATG",
    label: "Antigua and Barbuda",
    value: "antigua-and-barbuda",
    lat: null,
    lon: null
  },
  {
    country_id: 59,
    iso_country_code: "ar",
    world_bank_country_code: "ARG",
    label: "Argentina",
    value: "argentina",
    lat: -35.39,
    lon: -64.92
  },
  {
    country_id: 60,
    iso_country_code: "am",
    world_bank_country_code: "ARM",
    label: "Armenia",
    value: "armenia",
    lat: 40.31,
    lon: 45.22
  },
  {
    country_id: 253,
    iso_country_code: "aw",
    world_bank_country_code: "ABW",
    label: "Aruba",
    value: "aruba",
    lat: null,
    lon: null
  },
  {
    country_id: 61,
    iso_country_code: "au",
    world_bank_country_code: "AUS",
    label: "Australia",
    value: "australia",
    lat: -25.85,
    lon: 134.61
  },
  {
    country_id: 62,
    iso_country_code: "at",
    world_bank_country_code: "AUT",
    label: "Austria",
    value: "austria",
    lat: 47.6,
    lon: 14.32
  },
  {
    country_id: 63,
    iso_country_code: "az",
    world_bank_country_code: "AZE",
    label: "Azerbaijan",
    value: "azerbaijan",
    lat: 40.27,
    lon: 47.82
  },
  {
    country_id: 229,
    iso_country_code: "bs",
    world_bank_country_code: "BHS",
    label: "Bahamas",
    value: "bahamas",
    lat: null,
    lon: null
  },
  {
    country_id: 232,
    iso_country_code: "bh",
    world_bank_country_code: "BHR",
    label: "Bahrain",
    value: "bahrain",
    lat: null,
    lon: null
  },
  {
    country_id: 68,
    iso_country_code: "bd",
    world_bank_country_code: "BGD",
    label: "Bangladesh",
    value: "bangladesh",
    lat: 23.81,
    lon: 90.42
  },
  {
    country_id: 237,
    iso_country_code: "bb",
    world_bank_country_code: "BRB",
    label: "Barbados",
    value: "barbados",
    lat: null,
    lon: null
  },
  {
    country_id: 71,
    iso_country_code: "by",
    world_bank_country_code: "BLR",
    label: "Belarus",
    value: "belarus",
    lat: 53.55,
    lon: 28.23
  },
  {
    country_id: 65,
    iso_country_code: "be",
    world_bank_country_code: "BEL",
    label: "Belgium",
    value: "belgium",
    lat: 50.66,
    lon: 4.83
  },
  {
    country_id: 72,
    iso_country_code: "bz",
    world_bank_country_code: "BLZ",
    label: "Belize",
    value: "belize",
    lat: 17.22,
    lon: -88.53
  },
  {
    country_id: 66,
    iso_country_code: "bj",
    world_bank_country_code: "BEN",
    label: "Benin",
    value: "benin",
    lat: 9.62,
    lon: 2.55
  },
  {
    country_id: 225,
    iso_country_code: "bm",
    world_bank_country_code: "BMU",
    label: "Bermuda",
    value: "bermuda",
    lat: 32.4,
    lon: 64.7
  },
  {
    country_id: 76,
    iso_country_code: "bt",
    world_bank_country_code: "BTN",
    label: "Bhutan",
    value: "bhutan",
    lat: 27.4,
    lon: 90.58
  },
  {
    country_id: 73,
    iso_country_code: "bo",
    world_bank_country_code: "BOL",
    label: "Bolivia",
    value: "bolivia",
    lat: -16.73,
    lon: -64.44
  },
  {
    country_id: 70,
    iso_country_code: "ba",
    world_bank_country_code: "BIH",
    label: "Bosnia and Herzegovina",
    value: "bosnia-and-herzegovina",
    lat: 44.18,
    lon: 17.99
  },
  {
    country_id: 77,
    iso_country_code: "bw",
    world_bank_country_code: "BWA",
    label: "Botswana",
    value: "botswana",
    lat: -22.26,
    lon: 23.96
  },
  {
    country_id: 254,
    iso_country_code: "bv",
    world_bank_country_code: "BVT",
    label: "Bouvet Island",
    value: "bouvet-island",
    lat: null,
    lon: null
  },
  {
    country_id: 74,
    iso_country_code: "br",
    world_bank_country_code: "BRA",
    label: "Brazil",
    value: "brazil",
    lat: -10.83,
    lon: -52.87
  },
  {
    country_id: 255,
    iso_country_code: "io",
    world_bank_country_code: "IOT",
    label: "British Indian Ocean Territory",
    value: "british-indian-ocean-territory",
    lat: null,
    lon: null
  },
  {
    country_id: 231,
    iso_country_code: "vg",
    world_bank_country_code: "BVI",
    label: "British Virgin Islands",
    value: "british-virgin-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 75,
    iso_country_code: "bn",
    world_bank_country_code: "BRN",
    label: "Brunei",
    value: "brunei",
    lat: 4.48,
    lon: 114.86
  },
  {
    country_id: 69,
    iso_country_code: "bg",
    world_bank_country_code: "BGR",
    label: "Bulgaria",
    value: "bulgaria",
    lat: 42.79,
    lon: 25.35
  },
  {
    country_id: 67,
    iso_country_code: "bf",
    world_bank_country_code: "BFA",
    label: "Burkina Faso",
    value: "burkina-faso",
    lat: 12.27,
    lon: -1.54
  },
  {
    country_id: 64,
    iso_country_code: "bi",
    world_bank_country_code: "BDI",
    label: "Burundi",
    value: "burundi",
    lat: -3.51,
    lon: 30.07
  },
  {
    country_id: 135,
    iso_country_code: "kh",
    world_bank_country_code: "KHM",
    label: "Cambodia",
    value: "cambodia",
    lat: 12.69,
    lon: 105.04
  },
  {
    country_id: 84,
    iso_country_code: "cm",
    world_bank_country_code: "CMR",
    label: "Cameroon",
    value: "cameroon",
    lat: 5.68,
    lon: 12.92
  },
  {
    country_id: 222,
    iso_country_code: "cv",
    world_bank_country_code: "CPV",
    label: "Cape Verde",
    value: "cape-verde",
    lat: 14.9,
    lon: 23.5
  },
  {
    country_id: 247,
    iso_country_code: "ky",
    world_bank_country_code: "KTD",
    label: "Cayman Islands",
    value: "cayman-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 78,
    iso_country_code: "cf",
    world_bank_country_code: "CAF",
    label: "Central African Republic",
    value: "central-african-republic",
    lat: 6.5,
    lon: 20.6
  },
  {
    country_id: 196,
    iso_country_code: "td",
    world_bank_country_code: "TCD",
    label: "Chad",
    value: "chad",
    lat: 15.31,
    lon: 18.81
  },
  {
    country_id: 81,
    iso_country_code: "cl",
    world_bank_country_code: "CHL",
    label: "Chile",
    value: "chile",
    lat: -35.82,
    lon: -70.89
  },
  {
    country_id: 82,
    iso_country_code: "cn",
    world_bank_country_code: "CHN",
    label: "China",
    value: "china",
    lat: 36.59,
    lon: 103.94
  },
  {
    country_id: 257,
    iso_country_code: "cx",
    world_bank_country_code: "CXR",
    label: "Christmas Island",
    value: "christmas-island",
    lat: null,
    lon: null
  },
  {
    country_id: 258,
    iso_country_code: "cc",
    world_bank_country_code: "CCK",
    label: "Cocos (Keeling) Islands",
    value: "cocos-keeling-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 86,
    iso_country_code: "co",
    world_bank_country_code: "COL",
    label: "Colombia",
    value: "colombia",
    lat: 3.88,
    lon: -72.87
  },
  {
    country_id: 259,
    iso_country_code: "km",
    world_bank_country_code: "COM",
    label: "Comoros",
    value: "comoros",
    lat: null,
    lon: null
  },
  {
    country_id: 85,
    iso_country_code: "cg",
    world_bank_country_code: "COG",
    label: "Congo, Republic of",
    value: "congo-republic-of",
    lat: -0.88,
    lon: 15.34
  },
  {
    country_id: 260,
    iso_country_code: "ck",
    world_bank_country_code: "COK",
    label: "Cook Islands",
    value: "cook-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 87,
    iso_country_code: "cr",
    world_bank_country_code: "CRI",
    label: "Costa Rica",
    value: "costa-rica",
    lat: 10.01,
    lon: -83.95
  },
  {
    country_id: 118,
    iso_country_code: "hr",
    world_bank_country_code: "HRV",
    label: "Croatia",
    value: "croatia",
    lat: 45.11,
    lon: 16.65
  },
  {
    country_id: 338,
    iso_country_code: "cw",
    world_bank_country_code: "CUW",
    label: "Curaçao",
    value: "curacao",
    lat: 12.1833,
    lon: -69
  },
  {
    country_id: 89,
    iso_country_code: "cy",
    world_bank_country_code: "CYP",
    label: "Cyprus",
    value: "cyprus",
    lat: 35.03,
    lon: 33.29
  },
  {
    country_id: 90,
    iso_country_code: "cz",
    world_bank_country_code: "CZE",
    label: "Czech Republic",
    value: "czech-republic",
    lat: 49.78,
    lon: 15.54
  },
  {
    country_id: 93,
    iso_country_code: "dk",
    world_bank_country_code: "DNK",
    label: "Denmark",
    value: "denmark",
    lat: 56.11,
    lon: 9.97
  },
  {
    country_id: 92,
    iso_country_code: "dj",
    world_bank_country_code: "DJI",
    label: "Djibouti",
    value: "djibouti",
    lat: 11.7,
    lon: 42.78
  },
  {
    country_id: 261,
    iso_country_code: "dm",
    world_bank_country_code: "DMA",
    label: "Dominica",
    value: "dominica",
    lat: null,
    lon: null
  },
  {
    country_id: 94,
    iso_country_code: "do",
    world_bank_country_code: "DOM",
    label: "Dominican Republic",
    value: "dominican-republic",
    lat: 18.95,
    lon: -70.32
  },
  {
    country_id: 96,
    iso_country_code: "ec",
    world_bank_country_code: "ECU",
    label: "Ecuador",
    value: "ecuador",
    lat: -1.46,
    lon: -78.19
  },
  {
    country_id: 97,
    iso_country_code: "eg",
    world_bank_country_code: "EGY",
    label: "Egypt",
    value: "egypt",
    lat: 26.41,
    lon: 30.03
  },
  {
    country_id: 187,
    iso_country_code: "sv",
    world_bank_country_code: "SLV",
    label: "El Salvador",
    value: "el-salvador",
    lat: 13.78,
    lon: -88.68
  },
  {
    country_id: 111,
    iso_country_code: "gq",
    world_bank_country_code: "GNQ",
    label: "Equatorial Guinea",
    value: "equatorial-guinea",
    lat: 1.64,
    lon: 10.48
  },
  {
    country_id: 98,
    iso_country_code: "er",
    world_bank_country_code: "ERI",
    label: "Eritrea",
    value: "eritrea",
    lat: 15.26,
    lon: 39.17
  },
  {
    country_id: 100,
    iso_country_code: "ee",
    world_bank_country_code: "EST",
    label: "Estonia",
    value: "estonia",
    lat: 58.63,
    lon: 25.99
  },
  {
    country_id: 101,
    iso_country_code: "et",
    world_bank_country_code: "ETH",
    label: "Ethiopia",
    value: "ethiopia",
    lat: 8.56,
    lon: 39.81
  },
  {
    country_id: 262,
    iso_country_code: "fk",
    world_bank_country_code: "FLK",
    label: "Falkland Islands (Malvinas)",
    value: "falkland-islands-malvinas",
    lat: null,
    lon: null
  },
  {
    country_id: 241,
    iso_country_code: "fo",
    world_bank_country_code: "FRO",
    label: "Faroe Islands",
    value: "faroe-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 234,
    iso_country_code: "fj",
    world_bank_country_code: "FJI",
    label: "Fiji",
    value: "fiji",
    lat: null,
    lon: null
  },
  {
    country_id: 102,
    iso_country_code: "fi",
    world_bank_country_code: "FIN",
    label: "Finland",
    value: "finland",
    lat: 64.43,
    lon: 26.45
  },
  {
    country_id: 103,
    iso_country_code: "fr",
    world_bank_country_code: "FRA",
    label: "France",
    value: "france",
    lat: 46.53,
    lon: 2.72
  },
  {
    country_id: 115,
    iso_country_code: "gf",
    world_bank_country_code: "GUF",
    label: "French Guiana",
    value: "french-guiana",
    lat: 3.86,
    lon: -52.97
  },
  {
    country_id: 263,
    iso_country_code: "pf",
    world_bank_country_code: "PYF",
    label: "French Polynesia",
    value: "french-polynesia",
    lat: null,
    lon: null
  },
  {
    country_id: 264,
    iso_country_code: "tf",
    world_bank_country_code: "ATF",
    label: "French Southern Territories",
    value: "french-southern-territories",
    lat: null,
    lon: null
  },
  {
    country_id: 104,
    iso_country_code: "ga",
    world_bank_country_code: "GAB",
    label: "Gabon",
    value: "gabon",
    lat: -0.65,
    lon: 11.99
  },
  {
    country_id: 109,
    iso_country_code: "gm",
    world_bank_country_code: "GMB",
    label: "Gambia",
    value: "gambia",
    lat: 13.46,
    lon: -15.3
  },
  {
    country_id: 106,
    iso_country_code: "ge",
    world_bank_country_code: "GEO",
    label: "Georgia",
    value: "georgia",
    lat: 42.18,
    lon: 43.77
  },
  {
    country_id: 91,
    iso_country_code: "de",
    world_bank_country_code: "DEU",
    label: "Germany",
    value: "germany",
    lat: 51.08,
    lon: 10.56
  },
  {
    country_id: 107,
    iso_country_code: "gh",
    world_bank_country_code: "GHA",
    label: "Ghana",
    value: "ghana",
    lat: 7.94,
    lon: -1.01
  },
  {
    country_id: 226,
    iso_country_code: "gi",
    world_bank_country_code: "GIB",
    label: "Gibraltar",
    value: "gibraltar",
    lat: null,
    lon: null
  },
  {
    country_id: 112,
    iso_country_code: "gr",
    world_bank_country_code: "GRC",
    label: "Greece",
    value: "greece",
    lat: 39.16,
    lon: 22.88
  },
  {
    country_id: 113,
    iso_country_code: "gl",
    world_bank_country_code: "GRL",
    label: "Greenland",
    value: "greenland",
    lat: 74.7,
    lon: -41.2
  },
  {
    country_id: 245,
    iso_country_code: "gd",
    world_bank_country_code: "GRD",
    label: "Grenada",
    value: "grenada",
    lat: null,
    lon: null
  },
  {
    country_id: 265,
    iso_country_code: "gp",
    world_bank_country_code: "GLP",
    label: "Guadeloupe",
    value: "guadeloupe",
    lat: null,
    lon: null
  },
  {
    country_id: 266,
    iso_country_code: "gu",
    world_bank_country_code: "GUM",
    label: "Guam",
    value: "guam",
    lat: null,
    lon: null
  },
  {
    country_id: 114,
    iso_country_code: "gt",
    world_bank_country_code: "GTM",
    label: "Guatemala",
    value: "guatemala",
    lat: 15.74,
    lon: -90.18
  },
  {
    country_id: 305,
    iso_country_code: "gg",
    world_bank_country_code: "GGY",
    label: "Guernsey",
    value: "guernsey",
    lat: null,
    lon: null
  },
  {
    country_id: 108,
    iso_country_code: "gn",
    world_bank_country_code: "GIN",
    label: "Guinea",
    value: "guinea",
    lat: 10.4,
    lon: -10.66
  },
  {
    country_id: 110,
    iso_country_code: "gw",
    world_bank_country_code: "GNB",
    label: "Guinea-Bissau",
    value: "guinea-bissau",
    lat: 12.08,
    lon: -14.64
  },
  {
    country_id: 116,
    iso_country_code: "gy",
    world_bank_country_code: "GUY",
    label: "Guyana",
    value: "guyana",
    lat: 4.74,
    lon: -58.7
  },
  {
    country_id: 119,
    iso_country_code: "ht",
    world_bank_country_code: "HTI",
    label: "Haiti",
    value: "haiti",
    lat: 18.98,
    lon: -72.49
  },
  {
    country_id: 267,
    iso_country_code: "hm",
    world_bank_country_code: "HMD",
    label: "Heard Island and McDonald Islands",
    value: "heard-island-and-mcdonald-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 268,
    iso_country_code: "va",
    world_bank_country_code: "VAT",
    label: "Holy See (Vatican City State)",
    value: "holy-see-vatican-city-state",
    lat: null,
    lon: null
  },
  {
    country_id: 117,
    iso_country_code: "hn",
    world_bank_country_code: "HND",
    label: "Honduras",
    value: "honduras",
    lat: 14.84,
    lon: -86.46
  },
  {
    country_id: 219,
    iso_country_code: "hk",
    world_bank_country_code: "HKG",
    label: "Hong Kong",
    value: "hong-kong",
    lat: 22.2823,
    lon: 114.15
  },
  {
    country_id: 120,
    iso_country_code: "hu",
    world_bank_country_code: "HUN",
    label: "Hungary",
    value: "hungary",
    lat: 47.21,
    lon: 19.61
  },
  {
    country_id: 126,
    iso_country_code: "is",
    world_bank_country_code: "ISL",
    label: "Iceland",
    value: "iceland",
    lat: 64.92,
    lon: -18.3
  },
  {
    country_id: 122,
    iso_country_code: "in",
    world_bank_country_code: "IND",
    label: "India",
    value: "india",
    lat: 22.93,
    lon: 79.81
  },
  {
    country_id: 121,
    iso_country_code: "id",
    world_bank_country_code: "IDN",
    label: "Indonesia",
    value: "indonesia",
    lat: -1.66,
    lon: 116.28
  },
  {
    country_id: 125,
    iso_country_code: "iq",
    world_bank_country_code: "IRQ",
    label: "Iraq",
    value: "iraq",
    lat: 32.95,
    lon: 43.99
  },
  {
    country_id: 123,
    iso_country_code: "ie",
    world_bank_country_code: "IRL",
    label: "Ireland",
    value: "ireland",
    lat: 53.16,
    lon: -7.96
  },
  {
    country_id: 269,
    iso_country_code: "im",
    world_bank_country_code: "IMN",
    label: "Isle of Man",
    value: "isle-of-man",
    lat: null,
    lon: null
  },
  {
    country_id: 127,
    iso_country_code: "il",
    world_bank_country_code: "ISR",
    label: "Israel",
    value: "israel",
    lat: 31.41,
    lon: 35.21
  },
  {
    country_id: 128,
    iso_country_code: "it",
    world_bank_country_code: "ITA",
    label: "Italy",
    value: "italy",
    lat: 42.88,
    lon: 12.27
  },
  {
    country_id: 83,
    iso_country_code: "ic",
    world_bank_country_code: "CIV",
    label: "Ivory Coast",
    value: "ivory-coast",
    lat: 7.61,
    lon: -5.33
  },
  {
    country_id: 129,
    iso_country_code: "jm",
    world_bank_country_code: "JAM",
    label: "Jamaica",
    value: "jamaica",
    lat: 18.19,
    lon: -77.15
  },
  {
    country_id: 131,
    iso_country_code: "jp",
    world_bank_country_code: "JPN",
    label: "Japan",
    value: "japan",
    lat: 36.96,
    lon: 138.85
  },
  {
    country_id: 307,
    iso_country_code: "je",
    world_bank_country_code: "JEY",
    label: "Jersey",
    value: "jersey",
    lat: null,
    lon: null
  },
  {
    country_id: 130,
    iso_country_code: "jo",
    world_bank_country_code: "JOR",
    label: "Jordan",
    value: "jordan",
    lat: 31.16,
    lon: 37.03
  },
  {
    country_id: 132,
    iso_country_code: "kz",
    world_bank_country_code: "KAZ",
    label: "Kazakhstan",
    value: "kazakhstan",
    lat: 48.19,
    lon: 67.56
  },
  {
    country_id: 133,
    iso_country_code: "ke",
    world_bank_country_code: "KEN",
    label: "Kenya",
    value: "kenya",
    lat: 0.42,
    lon: 38.01
  },
  {
    country_id: 270,
    iso_country_code: "ki",
    world_bank_country_code: "KIR",
    label: "Kiribati",
    value: "kiribati",
    lat: null,
    lon: null
  },
  {
    country_id: 271,
    iso_country_code: "kv",
    world_bank_country_code: "",
    label: "Kosovo",
    value: "kosovo",
    lat: null,
    lon: null
  },
  {
    country_id: 137,
    iso_country_code: "kw",
    world_bank_country_code: "KWT",
    label: "Kuwait",
    value: "kuwait",
    lat: 29.16,
    lon: 47.76
  },
  {
    country_id: 134,
    iso_country_code: "kg",
    world_bank_country_code: "KGZ",
    label: "Kyrgyzstan",
    value: "kyrgyzstan",
    lat: 41.49,
    lon: 74.82
  },
  {
    country_id: 138,
    iso_country_code: "la",
    world_bank_country_code: "LAO",
    label: "Laos",
    value: "laos",
    lat: 18.45,
    lon: 103.87
  },
  {
    country_id: 146,
    iso_country_code: "lv",
    world_bank_country_code: "LVA",
    label: "Latvia",
    value: "latvia",
    lat: 56.85,
    lon: 25.17
  },
  {
    country_id: 139,
    iso_country_code: "lb",
    world_bank_country_code: "LBN",
    label: "Lebanon",
    value: "lebanon",
    lat: 33.79,
    lon: 35.98
  },
  {
    country_id: 143,
    iso_country_code: "ls",
    world_bank_country_code: "LSO",
    label: "Lesotho",
    value: "lesotho",
    lat: -29.69,
    lon: 28.43
  },
  {
    country_id: 140,
    iso_country_code: "lr",
    world_bank_country_code: "LBR",
    label: "Liberia",
    value: "liberia",
    lat: 6.43,
    lon: -9.06
  },
  {
    country_id: 141,
    iso_country_code: "ly",
    world_bank_country_code: "LBY",
    label: "Libya",
    value: "libya",
    lat: 26.99,
    lon: 18.18
  },
  {
    country_id: 272,
    iso_country_code: "li",
    world_bank_country_code: "LIE",
    label: "Liechtenstein",
    value: "liechtenstein",
    lat: null,
    lon: null
  },
  {
    country_id: 144,
    iso_country_code: "lt",
    world_bank_country_code: "LTU",
    label: "Lithuania",
    value: "lithuania",
    lat: 55.35,
    lon: 24.06
  },
  {
    country_id: 145,
    iso_country_code: "lu",
    world_bank_country_code: "LUX",
    label: "Luxembourg",
    value: "luxembourg",
    lat: 49.78,
    lon: 6.3
  },
  {
    country_id: 273,
    iso_country_code: "mo",
    world_bank_country_code: "MAC",
    label: "Macao",
    value: "macao",
    lat: null,
    lon: null
  },
  {
    country_id: 151,
    iso_country_code: "mk",
    world_bank_country_code: "MKD",
    label: "Macedonia",
    value: "macedonia",
    lat: 41.57,
    lon: 21.91
  },
  {
    country_id: 149,
    iso_country_code: "mg",
    world_bank_country_code: "MDG",
    label: "Madagascar",
    value: "madagascar",
    lat: -19.43,
    lon: 46.92
  },
  {
    country_id: 158,
    iso_country_code: "mw",
    world_bank_country_code: "MWI",
    label: "Malawi",
    value: "malawi",
    lat: -13.53,
    lon: 34.49
  },
  {
    country_id: 159,
    iso_country_code: "my",
    world_bank_country_code: "MYS",
    label: "Malaysia",
    value: "malaysia",
    lat: 2.16,
    lon: 112.12
  },
  {
    country_id: 238,
    iso_country_code: "mv",
    world_bank_country_code: "MDV",
    label: "Maldives",
    value: "maldives",
    lat: null,
    lon: null
  },
  {
    country_id: 152,
    iso_country_code: "ml",
    world_bank_country_code: "MLI",
    label: "Mali",
    value: "mali",
    lat: 17.33,
    lon: -3.31
  },
  {
    country_id: 227,
    iso_country_code: "mt",
    world_bank_country_code: "MLT",
    label: "Malta",
    value: "malta",
    lat: null,
    lon: null
  },
  {
    country_id: 274,
    iso_country_code: "mh",
    world_bank_country_code: "MHL",
    label: "Marshall Islands",
    value: "marshall-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 275,
    iso_country_code: "mq",
    world_bank_country_code: "MTQ",
    label: "Martinique",
    value: "martinique",
    lat: null,
    lon: null
  },
  {
    country_id: 157,
    iso_country_code: "mr",
    world_bank_country_code: "MRT",
    label: "Mauritania",
    value: "mauritania",
    lat: 20.27,
    lon: -10.07
  },
  {
    country_id: 239,
    iso_country_code: "mu",
    world_bank_country_code: "MUS",
    label: "Mauritius",
    value: "mauritius",
    lat: null,
    lon: null
  },
  {
    country_id: 276,
    iso_country_code: "yt",
    world_bank_country_code: "MYT",
    label: "Mayotte",
    value: "mayotte",
    lat: null,
    lon: null
  },
  {
    country_id: 150,
    iso_country_code: "mx",
    world_bank_country_code: "MEX",
    label: "Mexico",
    value: "mexico",
    lat: 23.92,
    lon: -102.3
  },
  {
    country_id: 277,
    iso_country_code: "fm",
    world_bank_country_code: "FSM",
    label: "Micronesia, Federated States of",
    value: "micronesia-federated-states-of",
    lat: null,
    lon: null
  },
  {
    country_id: 148,
    iso_country_code: "md",
    world_bank_country_code: "MDA",
    label: "Moldova",
    value: "moldova",
    lat: 47.2,
    lon: 28.66
  },
  {
    country_id: 278,
    iso_country_code: "mc",
    world_bank_country_code: "MCO",
    label: "Monaco",
    value: "monaco",
    lat: null,
    lon: null
  },
  {
    country_id: 154,
    iso_country_code: "mn",
    world_bank_country_code: "MNG",
    label: "Mongolia",
    value: "mongolia",
    lat: 46.85,
    lon: 103.27
  },
  {
    country_id: 155,
    iso_country_code: "me",
    world_bank_country_code: "MON",
    label: "Montenegro",
    value: "montenegro",
    lat: 42.79,
    lon: 19.45
  },
  {
    country_id: 279,
    iso_country_code: "ms",
    world_bank_country_code: "MSR",
    label: "Montserrat",
    value: "montserrat",
    lat: null,
    lon: null
  },
  {
    country_id: 147,
    iso_country_code: "ma",
    world_bank_country_code: "MAR",
    label: "Morocco",
    value: "morocco",
    lat: 31.83,
    lon: -6.1
  },
  {
    country_id: 156,
    iso_country_code: "mz",
    world_bank_country_code: "MOZ",
    label: "Mozambique",
    value: "mozambique",
    lat: -17.29,
    lon: 35.73
  },
  {
    country_id: 153,
    iso_country_code: "mm",
    world_bank_country_code: "MMR",
    label: "Myanmar (Burma)",
    value: "myanmar-burma",
    lat: 21.17,
    lon: 96.67
  },
  {
    country_id: 160,
    iso_country_code: "na",
    world_bank_country_code: "NAM",
    label: "Namibia",
    value: "namibia",
    lat: -22.1,
    lon: 17.41
  },
  {
    country_id: 280,
    iso_country_code: "nr",
    world_bank_country_code: "NRU",
    label: "Nauru",
    value: "nauru",
    lat: null,
    lon: null
  },
  {
    country_id: 166,
    iso_country_code: "np",
    world_bank_country_code: "NPL",
    label: "Nepal",
    value: "nepal",
    lat: 28.3,
    lon: 84.17
  },
  {
    country_id: 243,
    iso_country_code: "an",
    world_bank_country_code: "ANT",
    label: "Netherlands Antilles",
    value: "netherlands-antilles",
    lat: null,
    lon: null
  },
  {
    country_id: 233,
    iso_country_code: "nc",
    world_bank_country_code: "NCL",
    label: "New Caledonia",
    value: "new-caledonia",
    lat: null,
    lon: null
  },
  {
    country_id: 167,
    iso_country_code: "nz",
    world_bank_country_code: "NZL",
    label: "New Zealand",
    value: "new-zealand",
    lat: -41.81,
    lon: 172.9
  },
  {
    country_id: 163,
    iso_country_code: "ni",
    world_bank_country_code: "NIC",
    label: "Nicaragua",
    value: "nicaragua",
    lat: 12.86,
    lon: -84.9
  },
  {
    country_id: 161,
    iso_country_code: "ne",
    world_bank_country_code: "NER",
    label: "Niger",
    value: "niger",
    lat: 17.42,
    lon: 9.58
  },
  {
    country_id: 162,
    iso_country_code: "ng",
    world_bank_country_code: "NGA",
    label: "Nigeria",
    value: "nigeria",
    lat: 9.58,
    lon: 8.28
  },
  {
    country_id: 281,
    iso_country_code: "nu",
    world_bank_country_code: "NIU",
    label: "Niue",
    value: "niue",
    lat: null,
    lon: null
  },
  {
    country_id: 282,
    iso_country_code: "nf",
    world_bank_country_code: "NFK",
    label: "Norfolk Island",
    value: "norfolk-island",
    lat: null,
    lon: null
  },
  {
    country_id: 283,
    iso_country_code: "mp",
    world_bank_country_code: "MNP",
    label: "Northern Mariana Islands",
    value: "northern-mariana-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 165,
    iso_country_code: "no",
    world_bank_country_code: "NOR",
    label: "Norway",
    value: "norway",
    lat: 67.47,
    lon: 15.77
  },
  {
    country_id: 168,
    iso_country_code: "om",
    world_bank_country_code: "OMN",
    label: "Oman",
    value: "oman",
    lat: 20.43,
    lon: 56.14
  },
  {
    country_id: 169,
    iso_country_code: "pk",
    world_bank_country_code: "PAK",
    label: "Pakistan",
    value: "pakistan",
    lat: 29.92,
    lon: 69.56
  },
  {
    country_id: 284,
    iso_country_code: "pw",
    world_bank_country_code: "PLW",
    label: "Palau",
    value: "palau",
    lat: null,
    lon: null
  },
  {
    country_id: 285,
    iso_country_code: "ps",
    world_bank_country_code: "PSE",
    label: "Palestine, State of",
    value: "palestine-state-of",
    lat: null,
    lon: null
  },
  {
    country_id: 170,
    iso_country_code: "pa",
    world_bank_country_code: "PAN",
    label: "Panama",
    value: "panama",
    lat: 8.57,
    lon: -79.91
  },
  {
    country_id: 173,
    iso_country_code: "pg",
    world_bank_country_code: "PNG",
    label: "Papua New Guinea",
    value: "papua-new-guinea",
    lat: -6.62,
    lon: 144.83
  },
  {
    country_id: 178,
    iso_country_code: "py",
    world_bank_country_code: "PRY",
    label: "Paraguay",
    value: "paraguay",
    lat: -23.2,
    lon: -58.17
  },
  {
    country_id: 171,
    iso_country_code: "pe",
    world_bank_country_code: "PER",
    label: "Peru",
    value: "peru",
    lat: -9.18,
    lon: -74.14
  },
  {
    country_id: 172,
    iso_country_code: "ph",
    world_bank_country_code: "PHL",
    label: "Philippines",
    value: "philippines",
    lat: 11.07,
    lon: 122.99
  },
  {
    country_id: 174,
    iso_country_code: "pl",
    world_bank_country_code: "POL",
    label: "Poland",
    value: "poland",
    lat: 52.14,
    lon: 19.64
  },
  {
    country_id: 177,
    iso_country_code: "pt",
    world_bank_country_code: "PRT",
    label: "Portugal",
    value: "portugal",
    lat: 39.69,
    lon: -7.76
  },
  {
    country_id: 175,
    iso_country_code: "pr",
    world_bank_country_code: "PRI",
    label: "Puerto Rico",
    value: "puerto-rico",
    lat: 18.28,
    lon: -66.32
  },
  {
    country_id: 179,
    iso_country_code: "qa",
    world_bank_country_code: "QAT",
    label: "Qatar",
    value: "qatar",
    lat: 25.23,
    lon: 51.43
  },
  {
    country_id: 304,
    iso_country_code: "re",
    world_bank_country_code: "REU",
    label: "Reunion",
    value: "reunion",
    lat: -21.1,
    lon: 55.6
  },
  {
    country_id: 180,
    iso_country_code: "ro",
    world_bank_country_code: "ROM",
    label: "Romania",
    value: "romania",
    lat: 45.91,
    lon: 25.18
  },
  {
    country_id: 181,
    iso_country_code: "ru",
    world_bank_country_code: "RUS",
    label: "Russia",
    value: "russia",
    lat: 61.7,
    lon: 96.86
  },
  {
    country_id: 182,
    iso_country_code: "rw",
    world_bank_country_code: "RWA",
    label: "Rwanda",
    value: "rwanda",
    lat: -2.08,
    lon: 30.07
  },
  {
    country_id: 286,
    iso_country_code: "sh",
    world_bank_country_code: "SHN",
    label: "Saint Helena",
    value: "saint-helena",
    lat: null,
    lon: null
  },
  {
    country_id: 287,
    iso_country_code: "kn",
    world_bank_country_code: "KNA",
    label: "Saint Kitts and Nevis",
    value: "saint-kitts-and-nevis",
    lat: null,
    lon: null
  },
  {
    country_id: 244,
    iso_country_code: "lc",
    world_bank_country_code: "LCA",
    label: "Saint Lucia",
    value: "saint-lucia",
    lat: null,
    lon: null
  },
  {
    country_id: 288,
    iso_country_code: "mf",
    world_bank_country_code: "MAF",
    label: "Saint Martin (French part)",
    value: "saint-martin-french-part",
    lat: null,
    lon: null
  },
  {
    country_id: 289,
    iso_country_code: "pm",
    world_bank_country_code: "SPM",
    label: "Saint Pierre and Miquelon",
    value: "saint-pierre-and-miquelon",
    lat: null,
    lon: null
  },
  {
    country_id: 249,
    iso_country_code: "vc",
    world_bank_country_code: "VCT",
    label: "Saint Vincent and the Grenadines",
    value: "saint-vincent-and-the-grenadines",
    lat: null,
    lon: null
  },
  {
    country_id: 290,
    iso_country_code: "ws",
    world_bank_country_code: "WSM",
    label: "Samoa",
    value: "samoa",
    lat: null,
    lon: null
  },
  {
    country_id: 291,
    iso_country_code: "sm",
    world_bank_country_code: "SMR",
    label: "San Marino",
    value: "san-marino",
    lat: null,
    lon: null
  },
  {
    country_id: 292,
    iso_country_code: "st",
    world_bank_country_code: "STP",
    label: "Sao Tome and Principe",
    value: "sao-tome-and-principe",
    lat: null,
    lon: null
  },
  {
    country_id: 183,
    iso_country_code: "sa",
    world_bank_country_code: "SAU",
    label: "Saudi Arabia",
    value: "saudi-arabia",
    lat: 23.93,
    lon: 44.68
  },
  {
    country_id: 185,
    iso_country_code: "sn",
    world_bank_country_code: "SEN",
    label: "Senegal",
    value: "senegal",
    lat: 14.45,
    lon: -14.23
  },
  {
    country_id: 189,
    iso_country_code: "rs",
    world_bank_country_code: "SRB",
    label: "Serbia",
    value: "serbia",
    lat: 44.05,
    lon: 20.99
  },
  {
    country_id: 293,
    iso_country_code: "sc",
    world_bank_country_code: "SYC",
    label: "Seychelles",
    value: "seychelles",
    lat: null,
    lon: null
  },
  {
    country_id: 186,
    iso_country_code: "sl",
    world_bank_country_code: "SLE",
    label: "Sierra Leone",
    value: "sierra-leone",
    lat: 8.54,
    lon: -11.51
  },
  {
    country_id: 220,
    iso_country_code: "sg",
    world_bank_country_code: "SGP",
    label: "Singapore",
    value: "singapore",
    lat: 1.3403,
    lon: 103.7758
  },
  {
    country_id: 337,
    iso_country_code: "sx",
    world_bank_country_code: "SXM",
    label: "Sint Maarten (Dutch part)",
    value: "sint-maarten-dutch-part",
    lat: 18.0667,
    lon: -63.05
  },
  {
    country_id: 191,
    iso_country_code: "sk",
    world_bank_country_code: "SVK",
    label: "Slovakia",
    value: "slovakia",
    lat: 48.79,
    lon: 19.75
  },
  {
    country_id: 192,
    iso_country_code: "si",
    world_bank_country_code: "SVN",
    label: "Slovenia",
    value: "slovenia",
    lat: 46.13,
    lon: 15.01
  },
  {
    country_id: 242,
    iso_country_code: "sb",
    world_bank_country_code: "SLB",
    label: "Solomon Islands",
    value: "solomon-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 188,
    iso_country_code: "so",
    world_bank_country_code: "SOM",
    label: "Somalia",
    value: "somalia",
    lat: 6.04,
    lon: 46.06
  },
  {
    country_id: 215,
    iso_country_code: "za",
    world_bank_country_code: "ZAF",
    label: "South Africa",
    value: "south-africa",
    lat: -29.05,
    lon: 25.22
  },
  {
    country_id: 294,
    iso_country_code: "gs",
    world_bank_country_code: "SGS",
    label: "South Georgia and the South Sandwich Islands",
    value: "south-georgia-and-the-south-sandwich",
    lat: null,
    lon: null
  },
  {
    country_id: 136,
    iso_country_code: "kr",
    world_bank_country_code: "KOR",
    label: "South Korea",
    value: "south-korea",
    lat: 36.45,
    lon: 127.94
  },
  {
    country_id: 339,
    iso_country_code: "ss",
    world_bank_country_code: "SSD",
    label: "South Sudan",
    value: "south-sudan",
    lat: 6.9833,
    lon: 30.45
  },
  {
    country_id: 99,
    iso_country_code: "es",
    world_bank_country_code: "ESP",
    label: "Spain",
    value: "spain",
    lat: 40.4,
    lon: -3.39
  },
  {
    country_id: 142,
    iso_country_code: "lk",
    world_bank_country_code: "LKA",
    label: "Sri Lanka",
    value: "sri-lanka",
    lat: 7.57,
    lon: 80.88
  },
  {
    country_id: 190,
    iso_country_code: "sr",
    world_bank_country_code: "SUR",
    label: "Surilabel",
    value: "surilabel",
    lat: 4.1,
    lon: -55.63
  },
  {
    country_id: 295,
    iso_country_code: "sj",
    world_bank_country_code: "SJM",
    label: "Svalbard and Jan Mayen",
    value: "svalbard-and-jan-mayen",
    lat: null,
    lon: null
  },
  {
    country_id: 194,
    iso_country_code: "sz",
    world_bank_country_code: "SWZ",
    label: "Swaziland",
    value: "swaziland",
    lat: -26.65,
    lon: 31.7
  },
  {
    country_id: 193,
    iso_country_code: "se",
    world_bank_country_code: "SWE",
    label: "Sweden",
    value: "sweden",
    lat: 62.75,
    lon: 16.86
  },
  {
    country_id: 80,
    iso_country_code: "ch",
    world_bank_country_code: "CHE",
    label: "Switzerland",
    value: "switzerland",
    lat: 46.84,
    lon: 8.35
  },
  {
    country_id: 204,
    iso_country_code: "tw",
    world_bank_country_code: "TWN",
    label: "Taiwan",
    value: "taiwan",
    lat: 23.64,
    lon: 121
  },
  {
    country_id: 199,
    iso_country_code: "tj",
    world_bank_country_code: "TJK",
    label: "Tajikistan",
    value: "tajikistan",
    lat: 38.51,
    lon: 71.28
  },
  {
    country_id: 205,
    iso_country_code: "tz",
    world_bank_country_code: "TZA",
    label: "Tanzania",
    value: "tanzania",
    lat: -6.4,
    lon: 35
  },
  {
    country_id: 198,
    iso_country_code: "th",
    world_bank_country_code: "THA",
    label: "Thailand",
    value: "thailand",
    lat: 15.08,
    lon: 101.14
  },
  {
    country_id: 164,
    iso_country_code: "nl",
    world_bank_country_code: "NLD",
    label: "Netherlands",
    value: "netherlands",
    lat: 52.21,
    lon: 5.82
  },
  {
    country_id: 296,
    iso_country_code: "tl",
    world_bank_country_code: "TLS",
    label: "Timor-Leste",
    value: "timor-leste",
    lat: null,
    lon: null
  },
  {
    country_id: 197,
    iso_country_code: "tg",
    world_bank_country_code: "TGO",
    label: "Togo",
    value: "togo",
    lat: 8.55,
    lon: 1.16
  },
  {
    country_id: 297,
    iso_country_code: "tk",
    world_bank_country_code: "TKL",
    label: "Tokelau",
    value: "tokelau",
    lat: null,
    lon: null
  },
  {
    country_id: 298,
    iso_country_code: "to",
    world_bank_country_code: "TON",
    label: "Tonga",
    value: "tonga",
    lat: null,
    lon: null
  },
  {
    country_id: 201,
    iso_country_code: "tt",
    world_bank_country_code: "TTO",
    label: "Trinidad",
    value: "trinidad",
    lat: 10.42,
    lon: -61.29
  },
  {
    country_id: 202,
    iso_country_code: "tn",
    world_bank_country_code: "TUN",
    label: "Tunisia",
    value: "tunisia",
    lat: 34.09,
    lon: 9.74
  },
  {
    country_id: 203,
    iso_country_code: "tr",
    world_bank_country_code: "TUR",
    label: "Turkey",
    value: "turkey",
    lat: 39.02,
    lon: 35.36
  },
  {
    country_id: 200,
    iso_country_code: "tm",
    world_bank_country_code: "TKM",
    label: "Turkmenistan",
    value: "turkmenistan",
    lat: 39.13,
    lon: 59.7
  },
  {
    country_id: 299,
    iso_country_code: "tc",
    world_bank_country_code: "TCA",
    label: "Turks and Caicos Islands",
    value: "turks-and-caicos-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 300,
    iso_country_code: "tv",
    world_bank_country_code: "TUV",
    label: "Tuvalu",
    value: "tuvalu",
    lat: null,
    lon: null
  },
  {
    country_id: 206,
    iso_country_code: "ug",
    world_bank_country_code: "UGA",
    label: "Uganda",
    value: "uganda",
    lat: 1.22,
    lon: 32.52
  },
  {
    country_id: 207,
    iso_country_code: "ua",
    world_bank_country_code: "UKR",
    label: "Ukraine",
    value: "ukraine",
    lat: 49.06,
    lon: 31.56
  },
  {
    country_id: 58,
    iso_country_code: "ae",
    world_bank_country_code: "ARE",
    label: "United Arab Emirates",
    value: "united-arab-emirates",
    lat: 23.54,
    lon: 54.3
  },
  {
    country_id: 302,
    iso_country_code: "um",
    world_bank_country_code: "UMI",
    label: "United States Minor Outlying Islands",
    value: "united-states-minor-outlying-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 208,
    iso_country_code: "uy",
    world_bank_country_code: "URY",
    label: "Uruguay",
    value: "uruguay",
    lat: -32.87,
    lon: -55.79
  },
  {
    country_id: 248,
    iso_country_code: "vi",
    world_bank_country_code: "VIR",
    label: "U.S. Virgin Islands",
    value: "us-virgin-islands",
    lat: null,
    lon: null
  },
  {
    country_id: 210,
    iso_country_code: "uz",
    world_bank_country_code: "UZB",
    label: "Uzbekistan",
    value: "uzbekistan",
    lat: 41.77,
    lon: 63.49
  },
  {
    country_id: 221,
    iso_country_code: "vu",
    world_bank_country_code: "VUT",
    label: "Vanuatu",
    value: "vanuatu",
    lat: 17.1,
    lon: 168.7
  },
  {
    country_id: 211,
    iso_country_code: "ve",
    world_bank_country_code: "VEN",
    label: "Venezuela",
    value: "venezuela",
    lat: 7.08,
    lon: -65.91
  },
  {
    country_id: 212,
    iso_country_code: "vn",
    world_bank_country_code: "VNM",
    label: "Vietnam",
    value: "vietnam",
    lat: 16.69,
    lon: 106.41
  },
  {
    country_id: 224,
    iso_country_code: "wf",
    world_bank_country_code: "WLF",
    label: "Wallis and Futuna",
    value: "wallis-and-futuna",
    lat: 13.2,
    lon: 176.2
  },
  {
    country_id: 213,
    iso_country_code: "eh",
    world_bank_country_code: "WSH",
    label: "Western Sahara",
    value: "western-sahara",
    lat: 24.62,
    lon: -12.9
  },
  {
    country_id: 214,
    iso_country_code: "ye",
    world_bank_country_code: "YEM",
    label: "Yemen",
    value: "yemen",
    lat: 15.79,
    lon: 47.82
  },
  {
    country_id: 216,
    iso_country_code: "cd",
    world_bank_country_code: "COD",
    label: "Zaire (Democratic Republic of Congo)",
    value: "zaire-democratic-republic-of-congo",
    lat: -2.92,
    lon: 23.77
  },
  {
    country_id: 217,
    iso_country_code: "zm",
    world_bank_country_code: "ZMB",
    label: "Zambia",
    value: "zambia",
    lat: -13.5,
    lon: 27.95
  },
  {
    country_id: 218,
    iso_country_code: "zw",
    world_bank_country_code: "ZWE",
    label: "Zimbabwe",
    value: "zimbabwe",
    lat: -19.06,
    lon: 30.06
  }
];



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/staticData/allCountries.js